import React from 'react';
import {css} from 'emotion';
import styled from 'styled-components';
import OutstationCabIcon from '../SvgComponents/icons/OutstationCabIcon.js';
import SelfDrivenIcon from '../SvgComponents/icons/SelfDrivenIcon.js';
import AirportTransferIcon from '../SvgComponents/icons/AirportTransferIcon.js';
import HourlyRentalIcon from '../SvgComponents/icons/HourlyRentalIcon.js';
/*global tw */

const Wrapper = styled.div`
    ${tw`   w-auto
            flex-no-wrap
            whitespace-no-wrap
            px-5
            py-3
            cursor-pointer
            select-none
            flex
            items-center
            lg:w-auto
            w-full
            justify-between
    `};
    font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
    font-weight: 700;
    letter-spacing: -0.005em;
    border-radius: 6px 6px 0 0;
    margin-right: 0.375rem;
    ${props => !props.active && tw`hidden lg:flex`};
    color: ${props => props.active ? '#F5F5F7' : 'rgba(255,255,255,0.75)'};
    background: ${props => props.active ? 'linear-gradient(135deg, #AA0BCA 0%, #5500DB 100%)' : 'rgba(255,255,255,0.04)'};
    border: 1px solid ${props => props.active ? 'transparent' : 'rgba(255,255,255,0.08)'};
    border-bottom: none;
    transition: all 0.22s ease;
    position: relative;
    ${props => props.active && `
        box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.35);
    `};
    p, span {
        color: inherit !important;
        -webkit-text-fill-color: inherit !important;
    }
    &:hover {
        background: ${props => props.active ? 'linear-gradient(135deg, #AA0BCA 0%, #5500DB 100%)' : 'rgba(255,255,255,0.07)'};
        color: ${props => props.active ? '#F5F5F7' : '#FFFFFF'};
        border-color: ${props => props.active ? 'transparent' : 'rgba(255,255,255,0.14)'};
    }
    @media (min-width: 992px){
        background: ${props => props.active ? 'linear-gradient(135deg, #AA0BCA 0%, #5500DB 100%)' : 'rgba(255,255,255,0.04)'};
    }
    /* On mobile only the active choice shows, so present it as a clear,
       fully-rounded "chooser" card rather than a tab attached to the form. */
    @media (max-width: 991px){
        margin-right: 0;
        padding: 0.85rem 1.1rem;
        border-radius: 12px;
        box-shadow: 0 12px 30px rgba(170, 11, 202, 0.32);
    }
`

const MobileLabel = styled.span`
    display: block;
    font-size: 0.625rem;
    font-weight: 700;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    opacity: 0.78;
    line-height: 1.1;
    margin-bottom: 2px;
    @media (min-width: 992px){
        display: none;
    }
`

const ChangePill = styled.div`
    ${tw`inline-flex items-center`};
    flex-shrink: 0;
    margin-left: 0.75rem;
    padding: 0.32rem 0.7rem;
    border-radius: 9999px;
    background: rgba(255, 255, 255, 0.18);
    border: 1px solid rgba(255, 255, 255, 0.32);
    span {
        font-size: 0.6875rem;
        font-weight: 700;
        letter-spacing: 0.04em;
        text-transform: uppercase;
        white-space: nowrap;
    }
    img {
        height: 0.45rem;
        width: auto;
        margin-left: 0.4rem;
        filter: brightness(0) invert(1);
    }
    @media (min-width: 992px){
        display: none;
    }
`

const RentingChoiceTab = (props) => (
    <Wrapper active={props.active} onClick={props.onClick}>
        <div className={css`${tw`inline-flex items-center`}`}>
            {props.type === 'OS' && 
                <OutstationCabIcon dark={props.active} 
                    height="24" 
                    opacity= {props.active? 1 : 0.9}
                    className={css`${tw`-mt-1 mr-4`}`}/>
            }
            {props.type === 'SD' && 
                <SelfDrivenIcon dark={props.active} 
                    height="24" 
                    opacity= {props.active? 1 : 0.9}
                    className={css`${tw`-mt-1 mr-4`}`}/>
            }
            {props.type === 'AT' && 
                <AirportTransferIcon dark={props.active} 
                    height="24" 
                    opacity= {props.active? 1 : 0.9}
                    className={css`${tw`-mt-1 mr-4`}`}/>
            }
            {props.type === 'HR' &&
                <HourlyRentalIcon dark={props.active}
                    height="24"
                    opacity= {props.active? 1 : 0.9}
                    className={css`${tw`-mt-1 mr-4`}`}/>
            }
            <div>
                <p className={css`${tw`lg:mt-1 font-bold text-lg tracking-halfpx lg:text-normal`}`}>{props.children}</p>
            </div>
        </div>
        <ChangePill>
            <span>Change</span>
            <img src={require('../SvgComponents/angle-down.svg')}/>
        </ChangePill>
    </Wrapper>
);

export default RentingChoiceTab;


